<script setup lang="ts">
import { Button } from '~/components/ui/button'
import { FeatureRateAlertDialog, type IOrganizationRateData } from '~/components/feature/rate-alert'
import { LucideBell } from 'lucide-vue-next'

const props = defineProps<{
  bankId?: number
  bankName?: string
  allOrganizationsRates?: IOrganizationRateData[]
}>()

const { t } = useI18n()
const { user } = useUser()
const authModalStore = useAuthModalStore()

const isDialogOpen = ref(false)

const openAlertForm = () => {
  // Check if user is authenticated
  if (!user.value) {
    authModalStore.openLoginModalWithAlert(t('rate_alert.auth_required_message'))
    return
  }

  isDialogOpen.value = true
}

</script>

<template>
  <div class="rounded-lg border-2 border-blue-600 bg-gradient-to-br from-blue-50 to-blue-100 p-4">
    <div class="mb-3 flex items-center gap-3">
      <div
        class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-600 shadow-md"
      >
        <LucideBell class="h-5 w-5 text-white" />
      </div>
      <Heading tag="h3" class="text-base font-bold text-blue-900">
        {{ $t('widget.rate_alert_sidebar.title') }}
      </Heading>
    </div>

    <p class="mb-3 text-sm text-gray-700">
      {{ $t('widget.rate_alert_sidebar.description') }}
    </p>

    <Button class="w-full bg-blue-600 hover:bg-blue-700" size="sm" @click="openAlertForm">
      <LucideBell class="mr-2 h-4 w-4" />
      {{ $t('widget.rate_alert_sidebar.button') }}
    </Button>
  </div>

  <!-- Rate Alert Dialog -->
  <FeatureRateAlertDialog
    :open="isDialogOpen"
    :title="$t('rate_alert.set_rate_alert')"
    currency-code="USD"
    :default-bank-id="props.bankId"
    :default-bank-name="props.bankName"
    default-type="buy"
    :all-organizations-rates="props.allOrganizationsRates"
    @update:open="isDialogOpen = $event"
  />
</template>
